/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.className : a tailwind class the would be implemented on span tag
 * @param props.strokeWidth : set the strokeWidth with px css
 */

interface PersonProps {
  color?: string
  className?: string
  strokeWidth?: string
}

const Truck = (props: PersonProps) => {
  const { color = '#364152' } = props

  return (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 2.33341C6.61929 2.33341 5.5 3.4527 5.5 4.83342C5.5 6.21413 6.61929 7.33342 8 7.33342C9.38071 7.33342 10.5 6.21413 10.5 4.83342C10.5 3.4527 9.38071 2.33341 8 2.33341ZM3.83333 4.83342C3.83333 2.53223 5.69881 0.666748 8 0.666748C10.3012 0.666748 12.1667 2.53223 12.1667 4.83342C12.1667 7.1346 10.3012 9.00008 8 9.00008C5.69881 9.00008 3.83333 7.1346 3.83333 4.83342ZM1.72039 11.8871C2.50179 11.1057 3.5616 10.6667 4.66667 10.6667H11.3333C12.4384 10.6667 13.4982 11.1057 14.2796 11.8871C15.061 12.6685 15.5 13.7283 15.5 14.8334V16.5001C15.5 16.9603 15.1269 17.3334 14.6667 17.3334C14.2064 17.3334 13.8333 16.9603 13.8333 16.5001V14.8334C13.8333 14.1704 13.5699 13.5345 13.1011 13.0656C12.6323 12.5968 11.9964 12.3334 11.3333 12.3334H4.66667C4.00363 12.3334 3.36774 12.5968 2.8989 13.0656C2.43006 13.5345 2.16667 14.1704 2.16667 14.8334V16.5001C2.16667 16.9603 1.79357 17.3334 1.33333 17.3334C0.873096 17.3334 0.5 16.9603 0.5 16.5001V14.8334C0.5 13.7283 0.938987 12.6685 1.72039 11.8871Z"
        fill={color}
      />
    </svg>
  )
}

export default Truck
